import * as action_types from '../actions/action_types';

const initialState = {
  isShowing: false,
  dataObj: '',
};

export const ExportFaultDataReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case action_types.SHOW_FAULT_EXPORT_DATA:
      return {
        ...state,
        isShowing: action.data.isShowing,
        dataObj: action.data.type,
        columnsObj: action.data.columnsObj,
        mapURL: action.data.mapURL,
      };
    case action_types.HIDE_FAULT_EXPORT_DATA:
      return {
        ...state,
        isShowing: action.data.isShowing,
      };
    default:
      return state;
  }
};
